export const maxWidth = '830px'
